import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";
export const AfterCloseAction = Schema.declare<() => void>((value): value is () => void => typeof value === "function");
export type AfterCloseAction = typeof AfterCloseAction.Type;
export class AfterCloseCommandFailure extends privateDependencyFailure<AfterCloseCommandFailure>()("AfterCloseCommandFailure", "palette after-close command") {}
export const afterCloseCommandFailure = (cause: unknown) => new AfterCloseCommandFailure({ cause: Redacted.make(cause) });
